<template>
  <v-app id="app">
    <v-main>
      <v-container class="text-xs-center" style="position: relative; top: 20%; margin:0 auto;">
        <v-layout row wrap class="text-xs-center">
          <v-flex>
            <v-card  class="mx-auto py-10" max-width="700">
              <v-row style="margin-top:0px">
                <v-col align="center">
                  <v-form style="width: 400px; height:380px" ref="loginFrm" v-model="validLogin" lazy-validation>
                    <div class="mx-3 mb-5">
                      <h2 class="mb-6 text-left">E3 Mobility</h2>
                      <div class="">
                        <v-text-field class="loginInput" v-model="uid" label="ID" required outlined :rules="emailRules" style="ime-mode: disabled"></v-text-field>
                      </div>
                    </div>
                    <div class="mx-3 mb-5">
                      <div class="">
                        <v-text-field class="loginInput" type="password" v-model="upwd" label="Password" required outlined :rules="passRules" v-on:keydown.enter.prevent='loginSubmit'></v-text-field>
                      </div>
                    </div>
                    <v-card-actions class="mx-1">
                      <v-btn color="#2c4f91" dark large block @click="loginSubmit">LOGIN</v-btn>
                    </v-card-actions>
                    <div class="mx-3 py-5" style="height:50px;font-size:13px;">
                      <div class="mb-6 text-left">© {{ new Date().getFullYear() }} E3Mobility inc. All rights reserved.</div>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">{{errorMessage}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Error')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.loginInput > .v-label { font-size: 16px !important; font-weight:800 }
.v-messages theme--light error--text {color:#ff5252 !important;}
</style>

<script>
import dayjs from 'dayjs'

export default {
  name:"login"  , 
  data() {
    return {
      loginInfo1: "", loginInfo2: "", loginInfo3:"",
      nowDTM:"",
      validLogin: true,
      uid: null, upwd: null, 
      emailRules: [ 
        v => !!v || ' ID is required',
        v => /^[a-zA-Z0-9]{4,15}$/.test(v) || ' ID is not in a valid format',
      ],
      passRules: [ 
        v => !!v || ' Password is required',
        v => /^[a-zA-Z0-9]{8,15}$/.test(v) || ' Password is not in a valid format',
      ],
      asyncErrors: false, errorMessage:"Account is invalid or unauthorized",
    };
  },

  beforeCreate() {
      let uuid = localStorage.getItem("e3MngID");
      let uauthcode = localStorage.getItem("e3MngCode"); 
      if(uuid != '' && uauthcode !='') {
          var  requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
          };
          fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
          .then((response) => {
              if(response.ok) {
                  return response.json();
              }
              throw new Error('Network response was not ok');
          })
          .then((json) => {
              if(json.result == "success") {
                this.$router.replace('Vehicle');
              }
          }).catch((error) => {
              console.log(error);
          });
      } 
  },

  methods: {
    validate() {
      this.$refs.loginFrm.validate();
    },
    resetValidation() {
      this.$refs.loginFrm.resetValidation();
    },

    loginSubmit() {
      //console.log("start");
      this.validLogin = this.$refs.loginFrm.validate();

      //console.log("validLogin="+this.validLogin);
      
      if(this.validLogin) {
        
        var  requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "uid": this.uid, "upwd": this.upwd})
        };
              
        fetch('https://api.e3bss.com/_APP/POC/login.php', requestOptions)
        .then((response) => {
            if(response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok');
        })
        .then((json) => {
          //console.log(json );
          //console.log(json.result);
          if(json.result == "success") {
            this.nowDTM = dayjs().format("YYYY-MM-DD HH:mm:ss");
            localStorage.setItem("e3MngID", this.uid); 
            localStorage.setItem("e3MngNM", json.unm); 
            localStorage.setItem("e3MngDep", json.department); 
            localStorage.setItem("e3MngPos", json.position); 
            localStorage.setItem("e3MngLevel", json.authLevel); 
            localStorage.setItem("e3MngCode", json.authCode); 
            localStorage.setItem("e3MnglgDTM", this.nowDTM); 
            
            this.$router.push('Vehicle');
          } else {
           
            this.asyncErrors = true;
          } 
        }).catch(() => {
            //console.log(error);
            this.$router.replace('Error');
        });
      
      }
    },

    closeDialog(cls) {
        if(cls == "Success") {
            this.asyncSuccess = false;
        } else if(cls == "Error") {
            this.asyncErrors = false;
        }
    },

  },
};
</script>